export const ToastNotificationTypes = {
  ERROR: 'ERROR' as const,
  SUCCESS: 'SUCCESS' as const,
};
